import React from 'react';

interface CodeBlockProps {
  code: string;
  language?: 'jsx' | 'tsx' | 'css' | 'html';
  showLineNumbers?: boolean;
  className?: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({
  code,
  language = 'tsx',
  showLineNumbers = true,
  className = ''
}) => {
  // Simple syntax highlighting (in a real app, you would use a library like prism.js)
  const formatCode = (code: string) => {
    return code
      .replace(/import .*/g, '<span class="text-blue-400">$&</span>')
      .replace(/export .*/g, '<span class="text-blue-400">$&</span>')
      .replace(/const .*/g, '<span class="text-green-400">$&</span>')
      .replace(/function .*/g, '<span class="text-green-400">$&</span>')
      .replace(/return .*/g, '<span class="text-purple-400">$&</span>')
      .replace(/className="[^"]*"/g, '<span class="text-yellow-400">$&</span>')
      .replace(/<[^>]*>/g, '<span class="text-red-400">$&</span>');
  };

  const codeLines = code.trim().split('\n');
  
  return (
    <div className={`bg-osrs-black border-3 border-osrs-border rounded overflow-x-auto ${className}`}>
      <pre className="p-4 text-osrs-yellow font-mono text-sm">
        <code>
          {showLineNumbers ? (
            <div className="table w-full">
              {codeLines.map((line, index) => (
                <div key={index} className="table-row">
                  <span className="table-cell pr-4 text-right text-osrs-border select-none">
                    {index + 1}
                  </span>
                  <span 
                    className="table-cell" 
                    dangerouslySetInnerHTML={{ __html: formatCode(line) || '&nbsp;' }} 
                  />
                </div>
              ))}
            </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: formatCode(code) }} />
          )}
        </code>
      </pre>
    </div>
  );
};

export default CodeBlock; 